var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"border-b flex flex-col border-gray-300 bg-gray-600"},[_c('div',{staticClass:"border-r align-center justify flex space-x-3 border-gray-500 p-5"},[_c('div',{staticClass:"self-center"},[_c('h2',{staticClass:"text-lg font-medium text-gray-50"},[_vm._v("SlidesLive Subtitles editor")])])])])])
}]

export { render, staticRenderFns }